import { registerMixin } from '@dygc/shared'
import { getComponentFactory } from '@/question/util'
import mixin from './mixin'
import SingleChoice from './SingleChoice'
import MultipleChoice from './MultipleChoice'
import NPSScale from './NPSScale'

const components = { SingleChoice, MultipleChoice, NPSScale }

registerMixin(components, mixin)
const getComponent = getComponentFactory(components)
export const ControlSettingComponent = {
  props: { ...mixin.props },
  render(h) {
    const Component = getComponent(this.question.question_type)
    return h(Component, {
      scopedSlots: this.$scopedSlots,
      props: { ...this.$props },
      on: { ...this.$listeners },
      key: this.question.q_id
    })
  }
}
